import { PopoverController } from '@inked/popover';

export class DropdownMenuController extends PopoverController {
  static values = {
    selectedItemSelector: {
      type: String,
      default: '[role="menuitemradio"][aria-checked="true"]',
    },
  };

  connect() {
    this.checkedItemsChanged = false;
  }

  hide(event) {
    super.hide(event);

    if (this.checkedItemsChanged) this.#dispatchChange();
  }

  hotkeys(event) {
    if (this.isOpen && event.key === ' ') {
      event.preventDefault();

      this.activeItem?.click();

      return;
    }

    super.hotkeys(event);
  }

  isSelectable(item) {
    return super.isSelectable(item)
      && item.querySelector('input')?.getAttribute('aria-disabled') !== 'true';
  }

  updateCheckedItems() {
    this.itemTargets.forEach(item => {
      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');

      if (input) item.setAttribute('aria-checked', input.checked);
    });

    this.checkedItemsChanged = true;

    // Items that hide the menu on click change after it has already closed.
    if (!this.isOpen) this.#dispatchChange();
  }

  #dispatchChange() {
    this.checkedItemsChanged = false;

    this.dispatch('change', {
      bubbles: true,
      detail: {
        value: this.itemTargets
          .map(item => item.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked'))
          .filter(Boolean)
          .map(input => input.value),
      },
    });
  }
}
